<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <!-- Overlay di caricamento -->
    <CustomOverlay :show="overlay_show" text="Richiesta in corso, attendere...">

      <!-- CARD PRICIPALE DI CONTENIMENTO DI TUTTO IL FORM -->
      <b-card :title="form_name" class="mr-1 ml-1">

        <!-- MODALE CON INFO STATICHE PER L'UTENTE - SOSTITUISCE I BLOCCHI COLORATI IN CIMA AL FORM -->
        <b-modal ref="static-info-modal"
          title="Rimborso Bollette - Note per l'utente"
          no-close-on-esc
          no-close-on-backdrop
          hide-header-close
          size='xl'>
          <p class="text-justify">
            <b>Anche per l'anno {{anno_corrente}}</b>, come indicato dalla Legge n.213 del 30 dicembre 2023, <b>viene confermata la possibilità di richiedere il rimborso delle spese luce, gas e acqua</b>
            ; si richiama la circolare 35/E del 04/11/2022 dell'Agenzia delle Entrate per i chiarimenti sul tema:
          </p>
          <ul class="text-justify" >
            <li>
                <i><b>Principio del rimborso:</b></i> Sono rimborsabili tutte le fatture/bollette riferite ad utenze maturate nell'anno {{anno_corrente}}
            </li>
            <li>
                <i><b>Immobili considerati e intestatario della fattura:</b></i> Sono rimborsabili dal beneficiario le bollette per immobili ad uso
                abitativo con intestatario fattura e pagatore oltre il dipendente, il coniuge (a carico/non a carico) o il familiare
                (a carico/non a carico) indicati nell'art.433 del Codice Civile vigente, richiamato dall'art. 12 del Testo Unico Imposte sui Redditi:
                <ul class="text-justify" >
                  <li>il coniuge (unito civilmente non legalmente ed effettivamente separato) non il convivente di fatto</li>
                  <li>i figli (legittimi o legittimati o naturali o adottivi), e, in loro mancanza, i discendenti prossimi (anche naturali)</li>
                  <li>i genitori e, in loro mancanza, gli ascendenti prossimo, anche naturali; gli adottanti</li>
                  <li>il partner nelle unioni civili (Legge 20 maggio 2016, n.76)</li>
                  <!-- <li>i generi e le nuore</li>
                  <li>il suocero e la suocera</li>
                  <li>i fratelli e le sorelle germani o unilaterali, con precedenza dei germani sugli unilaterali</li> -->
                </ul>
            </li>
          </ul>
          <p class="text-justify"><b>Per la circolare completa:</b> <a href="https://lp.welfarebit.it/hubfs/AdE_Circ35-2022.pdf" target="_blank">Clicca Qui</a></p>

          <template #modal-footer="{ cancel }">
            <b-button size="sm" variant="primary" @click="cancel()">
              Chiudi
            </b-button>
          </template>
        </b-modal>

        <b-alert variant="danger" class="text-justify" show>
          <p><b>Sono rimborsabili tutte le fatture/bollette riferite ad utenze maturate nell'anno {{anno_corrente}}</b></p>
        </b-alert>

        <b-form @submit.prevent="onSubmit">
          <!-- DATI DEL RIMBORSO SPESE -->
          <b-card title="Dati del rimborso" class="ml-1 mr-1 mt-2 mb-2">

            <!-- Oggetto del rimborso spese ( id categoria )-->
            <b-form-group id="group-oggetto"
              label="* Oggetto del rimborso:"
              label-for="oggetto"
            >
              <b-form-select id="oggetto"
                v-model="form.id_categ"
                :options="categorie_rimborso"
                required></b-form-select>
            </b-form-group>

            <!-- Importo del rimborso -->
            <b-form-group id="group-importo"
              label="* Importo da rimborsare:"
              label-for="importo"
              :invalidFeedback="importo_help_text"
              description="Indicare gli importi in Euro (iva inclusa)">
              <b-input-group prepend="€">
                <b-form-input
                  id="importo"
                  v-model="form.importo"
                  @keyup="check_importo"
                  :state="importo_state"
                  required
                ></b-form-input>
              </b-input-group>
            </b-form-group>

            <!-- Modale per caricamento doc di acquisto -->
            <b-form-group id="group-file-doc-acquisto"
                label="* Documento d'acquisto:">
              <FileUploadModal :file_kind="file_upload_modals.file_doc_acquisto.file_kind"
                               :add_button_text="'Carica il file'"
                               :remove_button_text="'Rimuovi il file'"
                               :exclude_file_options="[6,7,8,29,30]"
                               @fileIdReady="assegna_id_file"
                               @fileRemoved="rimuovi_id_file"/>
            </b-form-group>

            <!-- Modale per il caricamento dell'autocertificazione -->
            <b-form-group id="group-file-doc-autocert"
                label="* Autocertificazione per rimborso bollette:">
                <template #description>
                  <p class='text-justify'>
                     ATTENZIONE: Va allegata l'autocertificazione presente nell'area <b-link :to="{ 'name' : 'site-documentazione', 'params': { 'group_to_show' : 'rimb-bollette' } }"><b>Documentazione</b></b-link>
                     del portale per dichiarare che le medesime fatture non sono già state oggetto di richiesta di rimborso, totale o
                     parziale, nè presso il medesimo datore di lavoro nè presso altri datori
                  </p>
                </template>
              <FileUploadModal :file_kind="file_upload_modals.file_doc_autocert.file_kind"
                               :add_button_text="'Carica il file'"
                               :remove_button_text="'Rimuovi il file'"
                               :exclude_file_options="[16,24]"
                               @fileIdReady="assegna_id_file"
                               @fileRemoved="rimuovi_id_file"/>
            </b-form-group>

            <!-- Modale per caricamento doc di pagamento -->
            <b-form-group id="group-file-doc-pagamento"
                label="* Documento di pagamento:">
                <template #description>
                  <p class='text-justify'>
                    ATTENZIONE: Si intende solo ed esclusivamente il giustificativo di pagamento ed è fondamentale
                    che la data inserita sia quella in cui il pagamento è fisicamente stato effettuato
                  </p>
                </template>
              <FileUploadModal :file_kind="file_upload_modals.file_doc_pagamento.file_kind"
                               :add_button_text="'Carica il file'"
                               :remove_button_text="'Rimuovi il file'"
                               :exclude_file_options="[13,31]"
                               @fileIdReady="assegna_id_file"
                               @fileRemoved="rimuovi_id_file"/>
            </b-form-group>

            <!-- Modale per caricamento della doc aggiuntiva -->
            <b-form-group id="group-file-doc-aggiuntiva"
                label="Documentazione aggiuntiva:">
                <template #description>
                  <p class='text-justify'>
                    ATTENZIONE: Da caricare solo se come DOCUMENTO DI PAGAMENTO si è inserita
                    un'Autocertificazione di pagamento per contanti.
                  </p>
                </template>
              <FileUploadModal :file_kind="file_upload_modals.file_doc_aggiuntiva.file_kind"
                               :add_button_text="'Ricevuta del pagamento effettuato'"
                               :remove_button_text="'Rimuovi la documentazione'"
                               :exclude_file_options="[17,18,22,23]"
                               @fileIdReady="assegna_id_file"
                               @fileRemoved="rimuovi_id_file"/>
            </b-form-group>
          </b-card>

          <!-- DATI DELL'UTENTE DA MOSTRARE IN MANIERA STATICA -->
          <b-card title="I miei dati anagrafici" class="ml-1 mr-1 mt-2 mb-2">

            <!-- Nome utente -->
            <b-form-group id="group-nome-utente"
              label="Nome:"
              label-for="nome-utente">
              <b-form-input
                id="nome-utente"
                v-model="user_data.nome"
                :disabled="true"
              ></b-form-input>
            </b-form-group>

            <!-- Cognome utente -->
            <b-form-group id="group-cognome-utente"
              label="Cognome:"
              label-for="cognome-utente">
              <b-form-input
                id="cognome-utente"
                v-model="user_data.cognome"
                :disabled="true"
              ></b-form-input>
            </b-form-group>

            <!-- Cognome utente -->
            <b-form-group id="group-cod-fisc"
              label="Cod. Fiscale:"
              label-for="cod-fisc">
              <b-form-input
                id="cod-fisc"
                v-model="user_data.cod_fisc"
                :disabled="true"
              ></b-form-input>
            </b-form-group>

          </b-card>

          <!-- Pulsante di invio -->
          <b-button type="submit" variant="primary" class="mr-1">Invia richiesta</b-button>

        </b-form>
      </b-card>
    </CustomOverlay>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import FileUploadModal from '@/components/FileUploadModal'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'RimborsoBollette',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Rimborso Bollette", link : 'rimb-bollette' } ],
      form_name : "Rimborso Bollette",
      overlay_show: false, // overlay con spinner per indicare che il sistema sta lavorando

       // il kind del rimborso art51c3
      form_kind : 13,

      // Categorie di rimborso selezionabili
      categorie_rimborso : [
        { value: null, text: "Seleziona un'opzione", disabled: true }
      ],

      // Dati del form
      form : {
        id_categ : null,
        importo : null,
        // Array con gli id dei files da associare all'acquisto
        docs : []
      },

      // Stato dell'importo per visualizzare se stiamo sforando il credito
      importo_state : null,

      // Dati per inizilizzare le modali di caricamento files ed ospitare i dati di
      // ritorno da esse.
      file_upload_modals : {
        file_doc_pagamento : { file_kind : 'doc_pagam', doc_id : null },
        file_doc_acquisto: { file_kind: 'doc_acq', doc_id : null },
        file_doc_aggiuntiva : { file_kind: 'doc_extra', doc_id : null },
        file_doc_autocert : { file_kind: 'doc_fam', doc_id : null }
      },

      // I dati utente da mostrare a schermo come datii anagrafici
      user_data : {
        nome : this.$store.state.user.user_anag.nome,
        cognome : this.$store.state.user.user_anag.cognome,
        cod_fisc : this.$store.state.user.user_anag.cod_fisc
      }

    }
  },
  computed : {
    /**
     * Visualizza un avviso per l'utente se dalla validazione della casella
     * dell'importo si evince che sta sforando il suo credito welfare.
     */
    importo_help_text : function () {
      if ( this.importo_state === false ) {
        let credito = this.$store.state.user.user_credito.art51c3;
        let mess = "Attenzione, l'importo immesso supera il tuo attuale credito welfare relativo " +
                   "al ART 51 C.3 che è di " + credito + " euro. Non sarai in grado di " +
                   "completare la richiesta.";
        return mess;
      } else {
        return '';
      }
    },

    anno_corrente : function () {
      return (new Date()).getFullYear()
    }
  },
  methods : {
    /**
     * Esecuzione dell'acquisto
     */
    onSubmit : function () {

      // Verifico innanzi tutto che ci siano tutti i files richiesti e compilo
      // l'array dei files da associare all'acquisto.
      if ( ! this.compila_array_docs() ) {
        return;
      }

      generalLib.acquisto_confirm_message_box (  this, this.form.importo, 'art51c3' )
      .then( ( value ) => {
        // L'utente ha risposto Annulla.
        if ( !value ) return;

        // Se invece l'utente decide di proseguire attivo
        // l'overlay e poi eseguo il post delle info.
        this.overlay_show = true;

        axios.post( apiUrl.welfareapi.create_acq_rimbart51c3 , this.form )
        .then( (response) => {

          // Visualizza la finestra di completamento, la quale alla chiusura ci riporta
          // alla home.
          generalLib.acquisto_complete_message_box( this, response.data.id_acquisto )
          .then ( ( val ) => {
              this.$router.push( { name : 'menu'} );
          });

        })
        .catch( (error) => {
            this.overlay_show = false;
            generalLib.backend_error_message_box( this, error.response.data );
        });

      })
      .catch( ( error ) => {
        console.error( error );
      });
    },
    /**
     * Verifica la presenza dei files che sono richiesti e compila l'array docs con
     * gli id degli stessi.
     * Torna true se tutti i files che devono essere presenti ci sono altrimenti torna
     * false.
     */
    compila_array_docs : function () {

      // Puliamo prima l'array
      this.form.docs = new Array();

      // Il file del documento di acquisto è richiesto
      if ( this.file_upload_modals.file_doc_acquisto.doc_id === null ) {
        generalLib.backend_error_message_box( this, "E' necessario caricare il file relativo al documento di acquisto per proseguire" );
        return false;
      }
      this.form.docs.push( this.file_upload_modals.file_doc_acquisto.doc_id );

      // Il file dell'autocertificazione è richiesto
      if ( this.file_upload_modals.file_doc_autocert.doc_id === null ) {
        generalLib.backend_error_message_box( this, "E' necessario caricare il file relativo all'autocertificazione per proseguire" );
        return false;
      }
      this.form.docs.push( this.file_upload_modals.file_doc_autocert.doc_id );

      // Il file del documento di pagamento è richiesto
      if ( this.file_upload_modals.file_doc_pagamento.doc_id === null ) {
        generalLib.backend_error_message_box( this, "E' necessario caricare il file relativo al documento di pagamento per proseguire" );
        return false;
      }
      this.form.docs.push( this.file_upload_modals.file_doc_pagamento.doc_id );

      // La documentazione aggiuntiva può essere inclusa o meno, quindi verifichiamo che non
      // sia null prima di caricarla.
      if ( this.file_upload_modals.file_doc_aggiuntiva.doc_id !== null ) {
        this.form.docs.push( this.file_upload_modals.file_doc_aggiuntiva.doc_id );
      }
      return true;

    },
    /**
     * Chiamata quando le modali di upload dei files restituiscono dati,
     * assegna all'oggetto interno dedicato ai files i valori tornati.
     */
    assegna_id_file : function ( data ) {
      if ( data.file_kind === 'doc_pagam' ) {
        this.file_upload_modals.file_doc_pagamento.doc_id = data.doc_id;
      }
      if ( data.file_kind === 'doc_acq' ) {
        this.file_upload_modals.file_doc_acquisto.doc_id = data.doc_id;
      }
      if ( data.file_kind === 'doc_extra' ) {
        this.file_upload_modals.file_doc_aggiuntiva.doc_id = data.doc_id;
      }
      if ( data.file_kind === 'doc_fam' ) {
        this.file_upload_modals.file_doc_autocert.doc_id = data.doc_id;
      }
    },
    /**
     * Chiamata quando le modali di upload dei files tolgono via i documenti
     * rimuove gli id dall'oggetto interno del form.
     */
    rimuovi_id_file : function ( data ) {
      if ( data.file_kind === 'doc_pagam' ) {
        this.file_upload_modals.file_doc_pagamento.doc_id = null;
      }
      if ( data.file_kind === 'doc_acq' ) {
        this.file_upload_modals.file_doc_acquisto.doc_id = null;
      }
      if ( data.file_kind === 'doc_extra' ) {
        this.file_upload_modals.file_doc_aggiuntiva.doc_id = null;
      }
      if ( data.file_kind === 'doc_fam' ) {
        this.file_upload_modals.file_doc_autocert.doc_id = null;
      }
    },
    /**
     * Controlliamo che l'importo in euro sia nel formato corretto,
     * altrimenti rimuoviamo l'ultimo carattere scritto dall'utente.
     */
    check_importo : function () {
      if ( !generalLib.euro_is_valid( this.form.importo ) ){
        this.form.importo = this.form.importo.slice(0,this.form.importo.length - 1);
      }
    },
    /**
     * Se stiamo operando in versione replay ( la prop id_acq_replay è settata ), va
     * a prendere i dati da usare per questo nuovo acquisto da un acquisto passato il cui
     * id viene passato dal router e posto per l'appunto nella prop id_acq_replay.
     */
    get_replay_data : function () {

      if ( this.id_acq_replay === null ) return;

      let api_url = apiUrl.welfareapi.acq_info_full.replace( '@id_acquisto', this.id_acq_replay );

      axios.get( api_url )
      .then( (response) => {
        // Se per qualche motivo l'acquisto non ha il kind giusto, non possiamo popolare il form.
        if ( response.data.kind != this.form_kind ) return;

        // Altrimenti valorissiamo i dati del form.
        this.form.id_categ = response.data.id_categ_id;
        this.form.importo = response.data.acquisto_row.importo_totale;

      })
      .catch( (error) => {
        generalLib.backend_error_message_box( this, error.response.data );
      });

    }
  },
  watch : {
    /**
     * Verifica in tempo reale se l'importo immesso supera l'attuale disponibilià
     * welfare dell'utente, se sfora segna lo stato dell'importo a false colorando
     * di rosso la casella di input.
     */
    'form.importo' : function ( val ) {
      let importo = parseFloat( val );
      if ( importo > this.$store.state.user.user_credito.art51c3 ){
        this.importo_state = false;
      } else {
        this.importo_state = null;
      }
    }
  },
  /**
   * Alla creazione del componente prendiamo dal backend i nomi e gli id delle possibile categorie
   * di acquisto. Andiamo anche a valorizzare l'oggetto interno "me_stesso" che ci dice se il beneficiario
   * della prestazione può essere solo un familiare o possiamo anche essere noi stessi.
   * Se siamo in modalità replay ( è stata passata la prop id_acq_replay con l'id dell'acquisto ) allora
   * il form viene popolato con tutti i dati che è possibile caricare.
   */
  created : function () {
    let api_url = apiUrl.welfareapi.acq_categ_kind.replace( '@kind', this.form_kind );
    axios.get( api_url )
      .then( (response) => {
        for (let elem of response.data) {
          this.categorie_rimborso.push({ value: elem.id, text: elem.nome });
        }
        // Se siamo in modalità replay prendiamo i dati per il form.
        this.get_replay_data();
    })
    .catch( (error) => {
        let mess = "Si è verificato un errore nel caricamento delle categorie di rimborso, " +
                   "non sarà possibile concludere correttamente la procedura. " +
                   "Tornare alla homepage e riprovare ad aprire il form. Se il problema persiste " +
                   "contattare l'assistenza."
        generalLib.backend_error_message_box( this, mess );
     })
  },
  /**
  * Quando la pagina è pronta visualizziamo la modale informativa per il servizio.
  */
  mounted : function () {
    this.$refs['static-info-modal'].show();
  },
  props : {
    /**
    * Prop che è passata dal router, se valorizzata indica l'acquisto da replicare
    * inserendo per l'utente i dati nel form.
    */
    id_acq_replay: {
      type: [String, Number],
      default : null
    }
  },
  components: {
    PageTagline,
    CustomOverlay,
    FileUploadModal
  }
}
</script>

<style scoped>
/* Vedi il form della previdenza integrativa per la spiegazione di questo
   workaround*/
#group-importo :deep( .invalid-feedback ) {
  display: block;
}
</style>